import type { Deal } from "~/models/Deal";
import type { Leasing } from "~/models/Leasing";
import type { PropertyBuildingOption } from "~/models/PropertyBuildingOption";
import type { PropertyRoomOption } from "~/models/PropertyRoomOption";

export type PropertyType = "room" | "building" | "parking_space" | "parking";
export type Property<T extends PropertyType> = {
	address: string;
	name: string;
	propertyId: number;
	roomNumber: T extends "room" | "parking_space" ? string : null;
	type: T;
	zipcode: string;
};

export const buildPropertyByDeal = (
	deal: Deal
): Property<PropertyType> | null => {
	if (deal.propertyType === null || deal.propertyId === null) return null;
	return {
		address: deal.address,
		name: deal.name,
		propertyId: deal.propertyId,
		roomNumber: deal.roomNumber,
		type: deal.propertyType,
		zipcode: ""
	};
};

export const buildPropertyByLeasing = (
	leasing: Leasing
): Property<PropertyType> | null => {
	if (leasing.amaterasPropertyId === null) return null;
	return {
		address: leasing.address ?? "",
		name: leasing.roomName ?? "",
		propertyId: leasing.amaterasPropertyId,
		roomNumber: leasing.roomNumber,
		type: leasing.amaterasPropertyType ?? "room",
		zipcode: "" // NSKDEV-1776 で追加予定
	};
};

export const buildPropertyByPropertyRoomOption = (
	propertyOption: PropertyRoomOption | null
): Property<"room"> | null => {
	if (propertyOption === null || propertyOption.amaterasPropertyId === null)
		return null;
	return {
		address: propertyOption.address,
		name: propertyOption.name,
		propertyId: propertyOption.amaterasPropertyId,
		roomNumber: propertyOption.roomNumber ?? "",
		type: "room",
		zipcode: ""
	};
};

export const buildPropertyByPropertyBuildingOption = (
	propertyOption: PropertyBuildingOption | null
): Property<"building"> | null => {
	if (propertyOption === null || propertyOption.amaterasPropertyId === null)
		return null;
	return {
		address: propertyOption.address,
		name: propertyOption.name,
		propertyId: propertyOption.amaterasPropertyId,
		roomNumber: null,
		type: "building",
		zipcode: ""
	};
};
